import type { SyncStatus } from '@weft/types';
import { SyncStatusSchema } from '@weft/types';
import { useStateParams } from '../../../../../hooks/use-state-params';
import { serializeStringArrayParam } from '../../../../../utils/params-formatting';

export function useContractSyncStatusesParam() {
  return useStateParams<SyncStatus[]>([], 'syncStatus', serializeStringArrayParam, deserializeContractSyncStatusArrayParam);
}

function deserializeContractSyncStatusArrayParam(contractSyncStatusesArrayStringified: string): SyncStatus[] | null {
  const statuses = contractSyncStatusesArrayStringified.split(',');

  return SyncStatusSchema.array().parse(statuses);
}